import qs from 'qs';

const parseQueryString = (string, options) => qs.parse(string.replace(/^\?/, ''), options);

const stringifyQueryString = (object, options) => `?${qs.stringify(object, options)}`;

export { parseQueryString, stringifyQueryString };
